export default "__VITE_ASSET__DPH7CX7N__"